import { ReactNode } from 'react';
import ListGridItem from './list-grid-item';
import useFollowArtist from '../three-dots-sheet/useFollowArtist';

export interface ArtistListGridItemProps {
    id: number;
    slug: string;
    name: string;
    imageUrl: string;
    imageUrl2x: string;
    subtitle: ReactNode;
}

/* Follow state is per-artist, so this needs to be its own component instance per row
 * rather than calling useFollowArtist inside a .map() callback. */
export function ArtistListGridItem({ id, slug, name, imageUrl, imageUrl2x, subtitle }: ArtistListGridItemProps) {
    const { isArtistFollowed, followArtist, unfollowArtist } = useFollowArtist(id);

    return (
        <ListGridItem
            id={id}
            title={name}
            subtitle={subtitle}
            rounded
            imageUrl={imageUrl}
            imageUrl2x={imageUrl2x}
            link={`/artist/${slug}`}
            contentType="artist"
            isFollowed={isArtistFollowed}
            onFollowToggle={() => (isArtistFollowed ? unfollowArtist() : followArtist())}
        />
    );
}

export default ArtistListGridItem;
